// removed by extract-text-webpack-plugin
module.exports = {"placeholder":"ImagePreview-module__placeholder___3CY3U","hidden":"ImagePreview-module__hidden___13-CT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Settings/ImagePreview/ImagePreview.module.sass
// module id = 1030
// module chunks = 0